import React, { useState } from "react";
import MediaPreview from "../../../Common/MediaPreview";
import { CloseSvg } from "../../../Svgs";
import { useTranslation } from "react-i18next";

const MessageMediaPreview = ({ attachments, setAttachments }) => {
  const { t } = useTranslation("common");
  const [previewMedia, setPreviewMedia] = useState();
  const handlePreview = (file) => {
    if (file?.type?.includes("image") || file?.type?.includes("video"))
      setPreviewMedia(file);
  };
  return (
    <div className="w-100 position-absolute bottom-100 start-0 pb-2 pt-3">
      <div className="d-flex gap-2 overflow-auto no-scroll pt-3">
        {attachments?.map((file, index) => {
          const objectURL = URL.createObjectURL(file);
          const fileName = file?.fileName ?? "";
          const isImage = file?.type?.includes("image");
          const isVideo = file?.type?.includes("video");
          return (
            <div key={fileName} className="position-relative">
              <button
                className="message-media-close position-absolute border-0 d-flex align-items-center justify-content-center bg-white p-2"
                onClick={() =>
                  setAttachments(attachments?.filter((_, i) => i !== index))
                }
              >
                <CloseSvg />
              </button>
              <button
                className="bg-lightGrey outline-none border-0 br5 overflow-hidden w-100px h-100px d-flex align-items-center justify-content-center"
                onClick={() => handlePreview(file)}
              >
                {isImage ? (
                  <img
                    src={objectURL}
                    alt={fileName}
                    className="ob-contain br5"
                    width={100}
                    height={100}
                  />
                ) : isVideo ? (
                  <video width={100} height={100}>
                    <source src={objectURL} type={file?.type} />
                  </video>
                ) : (
                  <p className="d-flex align-items-center justify-content-center mb-0 text-blue f14">
                    {t("Document")}
                  </p>
                )}
              </button>
            </div>
          );
        })}
      </div>
      {previewMedia && (
        <MediaPreview file={previewMedia} setPreviewMedia={setPreviewMedia} />
      )}
    </div>
  );
};

export default MessageMediaPreview;
